import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconHandshake: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="handshake, heart"><path d="M11.8297 5.48136C9.5212 3.17288 5.77841 3.17288 3.46993 5.48136C1.31715 7.63414 1.13585 11.0857 3.20619 13.3179C5.94312 16.2688 12 21 12 21C12 21 18.0569 16.2688 20.7938 13.3179C22.8641 11.0857 22.6828 7.63414 20.5301 5.48136C18.2216 3.17288 14.4788 3.17288 12.1703 5.48136L7.64981 10.0019L8.73736 11.0894C9.93863 12.2907 11.8863 12.2907 13.0875 11.0894L14.5376 9.63936L19.14 14.24" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconHandshake;
